import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      dashboard: "Dashboard",
      items_registry: "Items & Registry",
      log_repair: "Log Repair",
      parts_stock: "Parts & Stock",
      incidents: "Incidents",
      logout: "Logout",
      scan_qr: "Scan QR",
      welcome: "Welcome",
      recent_repairs: "Recent Repairs",
      new_repair: "New Repair Logged",
      view_ledger: "View Ledger"
    }
  },
  fr: {
    translation: {
      dashboard: "Tableau de Bord",
      items_registry: "Articles & Registre",
      log_repair: "Enregistrer Réparation",
      parts_stock: "Pièces & Stock",
      incidents: "Incidents",
      logout: "Déconnexion",
      scan_qr: "Scanner QR",
      welcome: "Bienvenue",
      recent_repairs: "Réparations Récentes",
      new_repair: "Nouvelle Réparation",
      view_ledger: "Voir le Grand Livre"
    }
  },
  es: {
    translation: {
      dashboard: "Panel",
      items_registry: "Artículos y Registro",
      log_repair: "Registrar Reparación",
      parts_stock: "Piezas y Stock",
      incidents: "Incidentes",
      logout: "Cerrar sesión",
      scan_qr: "Escanear QR",
      welcome: "Bienvenido",
      recent_repairs: "Reparaciones Recientes",
      new_repair: "Nueva Reparación",
      view_ledger: "Ver Libro Mayor"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "en", // default language
    fallbackLng: "en",
    interpolation: {
      escapeValue: false 
    }
  });

export default i18n;
